<script setup>
/**
 * Loading placeholder with configurable shape for content areas while data loads.
 *
 * @status internal
 * @group status-feedback
 * @see https://quasar.dev/vue-components/skeleton Quasar q-skeleton API
 */
defineOptions({ name: 'HrSkeleton' });

const props = defineProps({
  /**
   * Shape of the skeleton placeholder.
   * - rect: rectangular block (images, cards)
   * - text: text-line shimmer
   * - circle: circular (avatars, icons)
   * - pill: rounded pill (buttons, chips)
   * @values rect, text, circle, pill
   */
  type: {
    type: String,
    default: 'rect',
    validator: (v) => ['rect', 'text', 'circle', 'pill'].includes(v),
  },
  /** Explicit width as a CSS length string (e.g. '48px'). Defaults to 100% when not set. */
  width: {
    type: String,
    default: undefined,
  },
  /**
   * Explicit height as a CSS length string (e.g. '48px').
   * Defaults to the skeleton type's natural height when not set.
   */
  height: {
    type: String,
    default: undefined,
  },
});

const typeMap = {
  rect: 'rect',
  text: 'text',
  circle: 'circle',
  pill: 'QBtn',
};
</script>

<template>
  <q-skeleton
    :type="typeMap[props.type]"
    :width="props.width"
    :height="props.height"
    v-bind="$attrs"
  />
</template>
